import JSBI from 'jsbi'
import { keccak256 } from '@ethersproject/solidity'

// import { bytecode } from '@uniswap/v2-core/build/UniswapV2Pair.json'// exports for external consumption
import Pool from './Pool.json';

//0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f
console.log('Alliance Bytecode',keccak256(['bytes'], [Pool.bytecode]))
console.log('SDK Version 1.0.31')
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 1,
  MATIC_MUMBAI = 80001,
  EWC_VOLTA = 73799
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const FACTORY_ADDRESS = {
  // TODO Put the correct addresses
  [ChainId.MAINNET]: '0x6c998094dB40FC3295a0Cea34f5ACE795E2fDEC0',
  [ChainId.MATIC_MUMBAI] : '0x387BEa58533e617Da8f2A859054408db19a139E1',
  [ChainId.EWC_VOLTA]: '0xD84405250e245a93183622C8e1044dB27c1831A8'
}

export const ROUTER_ADDRESS = {
  // TODO Put the correct addresses
  [ChainId.MAINNET]: '0x7e29098eEd58A1A1a4422B4b2554cde99522194b',
  [ChainId.MATIC_MUMBAI] : '0x24f8CD8C906ddcAA2a1A69BEbE30cEe539e26C53',
  [ChainId.EWC_VOLTA]: '0xeE8a637344B4699A89Fd25FdC4DB07D3266Fe572'
}

export const ENSREGISTRAR_ADDRESS = {
  [ChainId.MAINNET]:'0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  [ChainId.MATIC_MUMBAI]:'0x29A5420df38ab5b62Da1480Ee4f8aA6Ee9EF92e6', //Matic address
  [ChainId.EWC_VOLTA]:'0xB2f58cA9cFf00a9e274CD425F5FBdC6Bb13C2457', // TODO ADDRESS HERE
}

export const ALBT_DEX_TOKEN_ADDRESS = {
  [ChainId.MAINNET]:'0x75B0107c25E329D9F8dC4160096D1BF64233e1c1', // change address i think
  [ChainId.MATIC_MUMBAI]:'0xbdBfCf1e9558625Ef4E99A02F294cad188938669',
  [ChainId.EWC_VOLTA]:'0x54F5A164a871E1F1fD29f6Bd13A3bB9a7e453408',
}

export const MULTICALL_NETWORKS_ADDRESS = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.MATIC_MUMBAI]: '0x08411ADd0b5AA8ee47563b146743C13b3556c9Cc', // from https://github.com/makerdao/multicall/pull/26/files
  [ChainId.EWC_VOLTA]: '0x780E8C8214e2f2a0Db93e226Ed80cC8bd3aC105C' // from https://github.com/makerdao/multicall/pull/26/files
}

export const MULTICALL_NETWORKS2_ADDRESS = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.MATIC_MUMBAI]: '0x71F4b753d1B602b94ef33D2CfA9E182e4530d754', // from https://github.com/makerdao/multicall/pull/26/files
  [ChainId.EWC_VOLTA]: '0x0F7593817E6D2D2df0F61831f12a0e37147676F4' // from https://github.com/makerdao/multicall/pull/26/files
}


export const INIT_CODE_HASH = '0xc48e9ec6b30400bb36d88a38e80402c17e3dce280f5318b6458306aaef04dd1f'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
